/* ============================================
   YOTPO FIXES - COMMENTED OUT
   ============================================ */


(function() {
  'use strict';

  // Adds necessary attributes to found SVGs
  function addAttributesToSvgs() {
    const svgElements = document.querySelectorAll('.yotpo-copy-text-button svg');
    
    svgElements.forEach(function(svg) {
      if (!svg.hasAttribute('role')) {
        svg.setAttribute('role', 'img');
      }
      if (!svg.hasAttribute('aria-label')) {
        svg.setAttribute('aria-label', 'Copy to clipboard');
      }
    });
  }

  // Adds aria-hidden to SVGs inside .yotpo-vip-tier-header
  function addAriaHiddenToVipTierSvgs() {
    const vipTierSvgs = document.querySelectorAll('.yotpo-vip-tier-header svg');
    
    vipTierSvgs.forEach(function(svg) {
      svg.setAttribute('aria-hidden', 'true');
    });
  }

  // Adds aria-hidden to disabled redemption buttons and creates span.znt-redeem-info
  // with the title attribute content after the button
  function addAriaHiddenToRedemptionButtons() {
    const disabledButtons = document.querySelectorAll('.yotpo-redemption-option-redeem-button[disabled]');
    
    disabledButtons.forEach(function(button) {
      // Adds aria-hidden to the button
      button.setAttribute('aria-hidden', 'true');
      
      // Checks if a span.znt-redeem-info already exists after this button
      const nextSibling = button.nextElementSibling;
      if (nextSibling && nextSibling.classList.contains('znt-redeem-info')) {
        // Already exists, no need to create again
        return;
      }
      
      // Gets the content of the title attribute
      const titleText = button.getAttribute('title') || '';
      
      // If there's no title, don't create the span
      if (!titleText.trim()) {
        return;
      }
      
      // Creates the span.znt-redeem-info with the title content
      const visuallyHiddenSpan = document.createElement('span');
      visuallyHiddenSpan.className = 'znt-redeem-info';
      visuallyHiddenSpan.textContent = titleText;
      
      // Inserts the span after the button
      button.insertAdjacentElement('afterend', visuallyHiddenSpan);
    });
  }

  // Adds aria-hidden to .yotpo-progress-bar-container and creates span.visually-hidden
  // with text content before the container, organized in the correct visual order
  function addAriaHiddenToProgressBar() {
    const progressBarContainers = document.querySelectorAll('.yotpo-progress-bar-container');
    
    progressBarContainers.forEach(function(container) {
      // Adds aria-hidden to the container
      container.setAttribute('aria-hidden', 'true');
      
      // Checks if a span.visually-hidden already exists before this container
      const previousSibling = container.previousElementSibling;
      if (previousSibling && previousSibling.classList.contains('visually-hidden')) {
        // Already exists, no need to create again
        return;
      }
      
      // Extracts text in the correct visual order
      const topLeft = container.querySelector('.yotpo-progress-bar-top-left');
      const topRight = container.querySelector('.yotpo-progress-bar-top-right');
      const bottomLeft = container.querySelector('.yotpo-progress-bar-bottom-left');
      const bottomRight = container.querySelector('.yotpo-progress-bar-bottom-right');
      
      // Helper function to capitalize first letter and clean text
      function getText(element) {
        if (!element) return '';
        const text = (element.textContent || element.innerText || '').trim();
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
      }
      
      // Helper function to get text without capitalization (for monetary values)
      function getTextRaw(element) {
        if (!element) return '';
        return (element.textContent || element.innerText || '').trim();
      }
      
      // Builds the text in the order: "You $0 Spent, Silver Spend $150."
      const topLeftText = getText(topLeft);
      const bottomLeftText = getTextRaw(bottomLeft);
      const topRightText = getText(topRight);
      const bottomRightText = getTextRaw(bottomRight);
      
      const leftPart = topLeftText + ' ' + bottomLeftText;
      const rightPart = topRightText + ' ' + bottomRightText;
      const textContent = leftPart + ', ' + rightPart + '.';
      
      // Creates the span.visually-hidden with organized text
      const visuallyHiddenSpan = document.createElement('span');
      visuallyHiddenSpan.className = 'visually-hidden';
      visuallyHiddenSpan.textContent = textContent;
      
      // Inserts the span before the container
      container.parentNode.insertBefore(visuallyHiddenSpan, container);
    });
  }

  // Initializes when the DOM is ready
  function init() {
    // Adds to existing elements after 2 seconds
    setTimeout(function() {
      addAttributesToSvgs();
      addAriaHiddenToVipTierSvgs();
      addAriaHiddenToProgressBar();
      addAriaHiddenToRedemptionButtons();
    }, 2000);

    // Observes DOM changes for dynamically loaded elements
    const observer = new MutationObserver(function(mutations) {
      addAttributesToSvgs();
      addAriaHiddenToVipTierSvgs();
      addAriaHiddenToProgressBar();
      addAriaHiddenToRedemptionButtons();
    });

    // Starts the observation
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Waits for the DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ============================================
   END YOTPO FIXES
   ============================================ */

/**
 * Wraps .product table.polaris-table elements with a container div
 * for accessibility purposes
 */
(function() {
  'use strict';

  /**
   * Wraps tables with the specified container div
   */
  /**
   * Removes tabindex="0" attribute from tables in .page__rte .rte__table-wrapper
   */
  function removeTabindexFromTables() {
    const tables = document.querySelectorAll('.page__rte .rte__table-wrapper');
    
    tables.forEach(function(table) {
      if (table.hasAttribute('tabindex') && table.getAttribute('tabindex') === '0') {
        table.removeAttribute('tabindex');
      }
    });
  }

  /**
   * Wraps tables with the specified container div
   */
  function wrapTables() {
    const tables = document.querySelectorAll('.product table.polaris-table');

    tables.forEach(function(table) {
      // Check if table is already wrapped
      if (table.parentElement && table.parentElement.classList.contains('znt-table-container')) {
        return;
      }
      
      // Create the wrapper div
      const wrapper = document.createElement('div');
      wrapper.className = 'znt-table-container';
      wrapper.setAttribute('tabindex', '0');
      wrapper.setAttribute('role', 'region');
      
      // Set aria-label on the table
      table.setAttribute('aria-label', 'Size and Fit');
      
      // Wrap the table
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  }

  /**
   * Initializes when the DOM is ready
   */
  function init() {
    // Wait 2 seconds, then wrap tables and remove tabindex
    setTimeout(function() {
      wrapTables();
      removeTabindexFromTables();
    }, 2000);

    // Observe DOM changes for dynamically loaded tables
    const observer = new MutationObserver(function(mutations) {
      wrapTables();
      removeTabindexFromTables();
    });

    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Wait for the DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ============================================
   HEADER NAV SCROLL BUTTONS - LIVE REGION ANNOUNCEMENTS
   Edited by Zenyth - announce scroll direction to screen readers
   ============================================ */
(function() {
  'use strict';

  var LIVE_REGION_ID = 'znt-header-scroll-live-region';
  var CLEAR_DELAY = 2000;
  var clearTimer = null;

  // Creates (once) a visually-hidden live region right next to the scroll container
  function getOrCreateLiveRegion(scrollContainer) {
    var existing = document.getElementById(LIVE_REGION_ID);
    if (existing) {
      return existing;
    }

    var liveRegion = document.createElement('div');
    liveRegion.id = LIVE_REGION_ID;
    liveRegion.className = 'visually-hidden';
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');
    liveRegion.setAttribute('role', 'status');

    // Place it right after the scroll container so it lives nearby
    scrollContainer.insertAdjacentElement('afterend', liveRegion);
    return liveRegion;
  }

  // Announces a message, then clears it after CLEAR_DELAY ms
  function announce(liveRegion, message) {
    liveRegion.textContent = message;

    if (clearTimer) {
      clearTimeout(clearTimer);
    }
    clearTimer = setTimeout(function() {
      liveRegion.textContent = '';
    }, CLEAR_DELAY);
  }

  function setup() {
    var scrollContainer = document.querySelector('.header__links-primary-scroll-container');
    if (!scrollContainer) {
      return;
    }
    // Avoid binding more than once (the observer below may fire repeatedly)
    if (scrollContainer.dataset.zntAnnounceBound === 'true') {
      return;
    }
    scrollContainer.dataset.zntAnnounceBound = 'true';

    var liveRegion = getOrCreateLiveRegion(scrollContainer);

    // Delegate so it keeps working even if the buttons are re-rendered
    scrollContainer.addEventListener('click', function(event) {
      var button = event.target.closest('.scroll-button');
      if (!button) {
        return;
      }

      var direction = button.getAttribute('data-direction');
      if (direction === 'forwards') {
        announce(liveRegion, 'Showing next links');
      } else if (direction === 'backwards') {
        announce(liveRegion, 'Showing previous links');
      }
    });
  }

  function init() {
    setup();

    // Re-run setup for dynamically rendered headers (e.g. theme editor)
    var observer = new MutationObserver(function() {
      setup();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ============================================
   SLIDESHOW PAUSE/PLAY BUTTON (a11y — WCAG 2.2.2)
   Edited by Zenyth - wire .znt-slideshow-pause to the hero slideshow autoplay
   The native Stiletto slideshow only auto-pauses via scroll observers; this
   gives the rendered .znt-slideshow-pause button a real click handler. Lives in
   zenyth-core.js (loaded asset) so it survives theme re-syncs.
   ============================================ */
(function() {
  'use strict';

  var L_PAUSE = 'Pause slideshow';
  var L_PLAY = 'Play slideshow';
  var ICON_PAUSE = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g><path d="M0 0h24v24H0z" fill="none"></path><path d="M6 5h2v14H6V5zm10 0h2v14h-2V5z"></path></g></svg>';
  var ICON_PLAY = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g><path d="M0 0h24v24H0z" fill="none"></path><path d="M8 5v14l11-7z"></path></g></svg>';

  // Resolve the Swiper instance for the slideshow that owns this button.
  // Swiper assigns its instance to the .swiper element's `swiper` property.
  function getSwiper(button) {
    var section = button.closest('[data-section-type="slideshow"], .shopify-section, .slideshow');
    var swiperEl = section ? section.querySelector('.swiper') : null;
    return swiperEl ? swiperEl.swiper : null;
  }

  // Visually-hidden polite announcement (mirrors the zenyth-pause-gif pattern).
  function announce(message) {
    var region = document.querySelector('.znt-live-region');
    if (!region) {
      region = document.createElement('div');
      region.className = 'znt-live-region visually-hidden';
      region.setAttribute('aria-live', 'polite');
      region.setAttribute('aria-atomic', 'true');
      document.body.appendChild(region);
    }
    region.textContent = message;
    setTimeout(function() { region.textContent = ''; }, 2000);
  }

  // Delegated so it keeps working if the slideshow is re-rendered (theme editor).
  document.addEventListener('click', function(event) {
    var button = event.target.closest('.znt-slideshow-pause');
    if (!button) return;

    var swiper = getSwiper(button);
    if (!swiper || !swiper.autoplay) return;

    if (button.dataset.zntPaused === 'true') {
      // ── PLAY ── restore the native start and resume.
      if (swiper._zntOrigStart) {
        swiper.autoplay.start = swiper._zntOrigStart;
      }
      swiper.autoplay.start();
      button.innerHTML = ICON_PAUSE;
      button.setAttribute('aria-label', L_PAUSE);
      button.dataset.zntPaused = 'false';
      announce('Slideshow playing');
    } else {
      // ── PAUSE ── stop autoplay AND neutralise the theme's scroll observer,
      // which calls autoplay.start() when the slideshow re-enters the viewport.
      // A user-initiated pause must stay paused (WCAG 2.2.2).
      if (!swiper._zntOrigStart) {
        swiper._zntOrigStart = swiper.autoplay.start;
      }
      swiper.autoplay.stop();
      swiper.autoplay.start = function() {};
      button.innerHTML = ICON_PLAY;
      button.setAttribute('aria-label', L_PLAY);
      button.dataset.zntPaused = 'true';
      announce('Slideshow paused');
    }
  });
})();
